import React from "react";
import usePageTitle from "../hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import "./LegalPage.css";

function CookiesPage() {
  const { t } = useTranslation();
  usePageTitle(t("cookies.pageTitle"));

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <h1 className="legal-title">{t("cookies.heroTitle")}</h1>
          <p className="legal-subtitle">{t("cookies.heroSubtitle")}</p>
        </div>
      </div>

      <div className="container">
        <div className="legal-content">
          <section className="legal-section">
            <h2>{t("cookies.s1Title")}</h2>
            <p>{t("cookies.s1Content")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("cookies.s2Title")}</h2>
            <p>{t("cookies.s2Content")}</p>
            <ul>
              <li>
                <b>{t("cookies.s2Item1Prefix")}</b>
                {t("cookies.s2Item1Suffix")}
              </li>
              <li>
                <b>{t("cookies.s2Item2Prefix")}</b>
                {t("cookies.s2Item2Suffix")}
              </li>
              <li>
                <b>{t("cookies.s2Item3Prefix")}</b>
                {t("cookies.s2Item3Suffix")}
              </li>
              <li>
                <b>{t("cookies.s2Item4Prefix")}</b>
                {t("cookies.s2Item4Suffix")}
                <ul>
                  <li>
                    <b>{t("cookies.s2Item4Sub1Prefix")}</b>
                    {t("cookies.s2Item4Sub1Suffix")}
                  </li>
                  <li>
                    <b>{t("cookies.s2Item4Sub2Prefix")}</b>
                    {t("cookies.s2Item4Sub2Suffix")}
                  </li>
                </ul>
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t("cookies.s3Title")}</h2>
            <p>
              {t("cookies.s3ContentPrefix")} <b>{t("cookies.s3ContentEssential")}</b> {t("cookies.s3ContentMid")} <b>{t("cookies.s3ContentThirdParty")}</b>{" "}
              {t("cookies.s3ContentSuffix")}
            </p>
          </section>

          <section className="legal-section">
            <h2>{t("cookies.s4Title")}</h2>
            <p>{t("cookies.s4Content")}</p>
            <button className="btn btn-primary" onClick={() => (window.location.hash = "manage-cookies")} style={{ marginTop: "10px" }}>
              {t("cookies.s4Button")}
            </button>
          </section>
        </div>
      </div>
    </div>
  );
}

export default CookiesPage;
